import { useSessionStorage } from 'lib/hooks/useStorage'

const key = 'sign-in-return-to-url'

const useReturnToSessionStorage = (): [string, (val: string) => void] =>
  useSessionStorage({
    key,
    defaultValue: '',
  })

export default useReturnToSessionStorage
